import React, { useState, useCallback, useRef, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import Toolbar, { Item } from "devextreme-react/toolbar";
import PrimaryTab from "./tabs/PrimaryTab";
import AdditionalTab from "./tabs/AdditionalTab";
import UserDefinedTab from "./tabs/UserDefinedTab";
import ChargesTab from "./tabs/ChargesTab";
import MinimumsTab from "./tabs/MinimumsTab";
import axios from "axios";
import data from "../../../../assets/apiRoutes.json";
import notify from 'devextreme/ui/notify';

function Form(props) {
    const history = useHistory();
    const formRefs = useRef({});
    const initialFormFields = {
        ROWID: '00000000-0000-0000-0000-000000000000',
        RECORD: '',
        R_PROFILECODE: null,
        R_CUSTOMER: '',
        ITEMCLASS: '',
        ITEMSUBCLASS: '',
        SCHEDULECODE: '',
        SCHEDULETYPE: '',
        DESCRIPTION: '',
        SCHEDULEAPPLY: '',
        POPUPMESSAGE: '',
        COMMENT: '',
        LOTSTORAGEENDDATE: '',
        SUBLOTSTORAGEENDDATE: '',
        RECURRINGSTORAGE: '',
        USERDEFINEDCODE1: '',
        USERDEFINEDCODE2: '',
        USERDEFINEDCODE3: '',
        USERDEFINEDCODE4: '',
        USERDEFINEDCODE5: '',
        USERDEFINEDCODE6: '',
        USERDEFINEDCODE7: '',
        USERDEFINEDCODE8: '',
        USERDEFINEDCODE9: '',
        USERDEFINEDCODE10: '',
        USERDEFINEDDATE1: null,
        USERDEFINEDDATE2: null,
        USERDEFINEDDATE3: null,
        USERDEFINEDDATE4: null,
        USERDEFINEDDATE5: null,
        USERDEFINEDDATE6: null,
        USERDEFINEDDATE7: null,
        USERDEFINEDDATE8: null,
        USERDEFINEDDATE9: null,
        USERDEFINEDDATE10: null,
        USERDEFINEDQUANTITY1: null,
        USERDEFINEDQUANTITY2: null,
        USERDEFINEDQUANTITY3: null,
        USERDEFINEDQUANTITY4: null,
        USERDEFINEDQUANTITY5: null,
        USERDEFINEDQUANTITY6: null,
        USERDEFINEDQUANTITY7: null,
        USERDEFINEDQUANTITY8: null,
        USERDEFINEDQUANTITY9: null,
        USERDEFINEDQUANTITY10: null,
        USERDEFINEDREFERENCE1: '',
        USERDEFINEDREFERENCE2: '',
        USERDEFINEDREFERENCE3: '',
        USERDEFINEDREFERENCE4: '',
        USERDEFINEDREFERENCE5: '',
        USERDEFINEDREFERENCE6: '',
        USERDEFINEDREFERENCE7: '',
        USERDEFINEDREFERENCE8: '',
        USERDEFINEDREFERENCE9: '',
        USERDEFINEDREFERENCE10: '',
        USERDEFINEDCOMMENT: '',
        APPLY_RECEIPT: '',
        APPLY_SHIPMENT: '',
        R_CHARGE_RECEIPT: null,
        R_CHARGE_SHIPMENT: null,
        MINIMUMAMOUNT_RECEIPT: null,
        MINIMUMAMOUNT_SHIPMENT: null,
        STATUS: 'A',
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const accessToken = props?.oidc?.user?.access_token;

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, []);

    const position = { of: '#accordion' };

    const handleFieldChange = useCallback((name, value) => {
        setformFields(prevFields => ({
            ...prevFields,
            [name]: value
        }));
    }, []);

    const loadRateScheduleHeaderById = useCallback(async (rowId) => {
        if (!rowId || rowId === '00000000-0000-0000-0000-000000000000') {
            return;
        }

        try {
            setLoadPanelVisible(true);
            const url = `${window._env_.REACT_APP_APIS}/${data.RateScheduleCode.GetRateScheduleHeader}?rowid=${rowId}`;
            const response = await axios.get(url, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.data) {
                const item = response.data;
                setformFields({
                    ROWID: item.RowId || initialFormFields.ROWID,
                    RECORD: item.Record || '',
                    R_PROFILECODE: item.RProfileCode || null,
                    R_CUSTOMER: item.RCustomer || '',
                    ITEMCLASS: item.ItemClass || '',
                    ITEMSUBCLASS: item.ItemSubClass || '',
                    SCHEDULECODE: item.ScheduleCode || '',
                    SCHEDULETYPE: item.ScheduleType || '',
                    DESCRIPTION: item.Description || '',
                    SCHEDULEAPPLY: item.ScheduleApply || '',
                    POPUPMESSAGE: item.PopupMessage || '',
                    COMMENT: item.Comment || '',
                    LOTSTORAGEENDDATE: item.LotStorageEndDate || '',
                    SUBLOTSTORAGEENDDATE: item.SublotStorageEndDate || '',
                    RECURRINGSTORAGE: item.RecurringStorage || '',
                    USERDEFINEDCODE1: item.UserDefinedCode1 || '',
                    USERDEFINEDCODE2: item.UserDefinedCode2 || '',
                    USERDEFINEDCODE3: item.UserDefinedCode3 || '',
                    USERDEFINEDCODE4: item.UserDefinedCode4 || '',
                    USERDEFINEDCODE5: item.UserDefinedCode5 || '',
                    USERDEFINEDCODE6: item.UserDefinedCode6 || '',
                    USERDEFINEDCODE7: item.UserDefinedCode7 || '',
                    USERDEFINEDCODE8: item.UserDefinedCode8 || '',
                    USERDEFINEDCODE9: item.UserDefinedCode9 || '',
                    USERDEFINEDCODE10: item.UserDefinedCode10 || '',
                    USERDEFINEDDATE1: item.UserDefinedDate1 || null,
                    USERDEFINEDDATE2: item.UserDefinedDate2 || null,
                    USERDEFINEDDATE3: item.UserDefinedDate3 || null,
                    USERDEFINEDDATE4: item.UserDefinedDate4 || null,
                    USERDEFINEDDATE5: item.UserDefinedDate5 || null,
                    USERDEFINEDDATE6: item.UserDefinedDate6 || null,
                    USERDEFINEDDATE7: item.UserDefinedDate7 || null,
                    USERDEFINEDDATE8: item.UserDefinedDate8 || null,
                    USERDEFINEDDATE9: item.UserDefinedDate9 || null,
                    USERDEFINEDDATE10: item.UserDefinedDate10 || null,
                    USERDEFINEDQUANTITY1: item.UserDefinedQuantity1 ?? null,
                    USERDEFINEDQUANTITY2: item.UserDefinedQuantity2 ?? null,
                    USERDEFINEDQUANTITY3: item.UserDefinedQuantity3 ?? null,
                    USERDEFINEDQUANTITY4: item.UserDefinedQuantity4 ?? null,
                    USERDEFINEDQUANTITY5: item.UserDefinedQuantity5 ?? null,
                    USERDEFINEDQUANTITY6: item.UserDefinedQuantity6 ?? null,
                    USERDEFINEDQUANTITY7: item.UserDefinedQuantity7 ?? null,
                    USERDEFINEDQUANTITY8: item.UserDefinedQuantity8 ?? null,
                    USERDEFINEDQUANTITY9: item.UserDefinedQuantity9 ?? null,
                    USERDEFINEDQUANTITY10: item.UserDefinedQuantity10 ?? null,
                    USERDEFINEDREFERENCE1: item.UserDefinedReference1 || '',
                    USERDEFINEDREFERENCE2: item.UserDefinedReference2 || '',
                    USERDEFINEDREFERENCE3: item.UserDefinedReference3 || '',
                    USERDEFINEDREFERENCE4: item.UserDefinedReference4 || '',
                    USERDEFINEDREFERENCE5: item.UserDefinedReference5 || '',
                    USERDEFINEDREFERENCE6: item.UserDefinedReference6 || '',
                    USERDEFINEDREFERENCE7: item.UserDefinedReference7 || '',
                    USERDEFINEDREFERENCE8: item.UserDefinedReference8 || '',
                    USERDEFINEDREFERENCE9: item.UserDefinedReference9 || '',
                    USERDEFINEDREFERENCE10: item.UserDefinedReference10 || '',
                    USERDEFINEDCOMMENT: item.UserDefinedComment || '',
                    APPLY_RECEIPT: item.ApplyReceipt || '',
                    APPLY_SHIPMENT: item.ApplyShipment || '',
                    R_CHARGE_RECEIPT: item.RChargeReceipt || null,
                    R_CHARGE_SHIPMENT: item.RChargeShipment || null,
                    MINIMUMAMOUNT_RECEIPT: item.MinimumAmountReceipt ?? null,
                    MINIMUMAMOUNT_SHIPMENT: item.MinimumAmountShipment ?? null,
                    STATUS: item.Status || 'A',
                });
            }
        } catch (error) {
            console.error('Error loading Rate Schedule Header:', error);
            notify('Failed to load Rate Schedule Header data.', 'error', 3000);
        } finally {
            setLoadPanelVisible(false);
        }
    }, [accessToken]);

    useEffect(() => {
        const rowId = props.id;
        if (rowId && rowId !== '00000000-0000-0000-0000-000000000000') {
            loadRateScheduleHeaderById(rowId);
        }
    }, [props.id, loadRateScheduleHeaderById]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoadPanelVisible(true);

        try {
            const payload = {
                RowId: formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000" ? formFields.ROWID : "00000000-0000-0000-0000-000000000000",
                KeySequence: 0,
                RProfileCode: formFields.R_PROFILECODE || null,
                RCustomer: formFields.R_CUSTOMER || null,
                ItemClass: formFields.ITEMCLASS || "",
                ItemSubClass: formFields.ITEMSUBCLASS || "",
                ScheduleCode: formFields.SCHEDULECODE || "",
                ScheduleType: formFields.SCHEDULETYPE || "",
                Description: formFields.DESCRIPTION || "",
                ScheduleApply: formFields.SCHEDULEAPPLY || "",
                PopupMessage: formFields.POPUPMESSAGE || "",
                Comment: formFields.COMMENT || "",
                LotStorageEndDate: formFields.LOTSTORAGEENDDATE || "",
                SublotStorageEndDate: formFields.SUBLOTSTORAGEENDDATE || "",
                RecurringStorage: formFields.RECURRINGSTORAGE || "",
                UserDefinedCode1: formFields.USERDEFINEDCODE1 || "",
                UserDefinedCode2: formFields.USERDEFINEDCODE2 || "",
                UserDefinedCode3: formFields.USERDEFINEDCODE3 || "",
                UserDefinedCode4: formFields.USERDEFINEDCODE4 || "",
                UserDefinedCode5: formFields.USERDEFINEDCODE5 || "",
                UserDefinedCode6: formFields.USERDEFINEDCODE6 || "",
                UserDefinedCode7: formFields.USERDEFINEDCODE7 || "",
                UserDefinedCode8: formFields.USERDEFINEDCODE8 || "",
                UserDefinedCode9: formFields.USERDEFINEDCODE9 || "",
                UserDefinedCode10: formFields.USERDEFINEDCODE10 || "",
                UserDefinedDate1: formFields.USERDEFINEDDATE1 || null,
                UserDefinedDate2: formFields.USERDEFINEDDATE2 || null,
                UserDefinedDate3: formFields.USERDEFINEDDATE3 || null,
                UserDefinedDate4: formFields.USERDEFINEDDATE4 || null,
                UserDefinedDate5: formFields.USERDEFINEDDATE5 || null,
                UserDefinedDate6: formFields.USERDEFINEDDATE6 || null,
                UserDefinedDate7: formFields.USERDEFINEDDATE7 || null,
                UserDefinedDate8: formFields.USERDEFINEDDATE8 || null,
                UserDefinedDate9: formFields.USERDEFINEDDATE9 || null,
                UserDefinedDate10: formFields.USERDEFINEDDATE10 || null,
                UserDefinedQuantity1: formFields.USERDEFINEDQUANTITY1 ?? null,
                UserDefinedQuantity2: formFields.USERDEFINEDQUANTITY2 ?? null,
                UserDefinedQuantity3: formFields.USERDEFINEDQUANTITY3 ?? null,
                UserDefinedQuantity4: formFields.USERDEFINEDQUANTITY4 ?? null,
                UserDefinedQuantity5: formFields.USERDEFINEDQUANTITY5 ?? null,
                UserDefinedQuantity6: formFields.USERDEFINEDQUANTITY6 ?? null,
                UserDefinedQuantity7: formFields.USERDEFINEDQUANTITY7 ?? null,
                UserDefinedQuantity8: formFields.USERDEFINEDQUANTITY8 ?? null,
                UserDefinedQuantity9: formFields.USERDEFINEDQUANTITY9 ?? null,
                UserDefinedQuantity10: formFields.USERDEFINEDQUANTITY10 ?? null,
                UserDefinedReference1: formFields.USERDEFINEDREFERENCE1 || "",
                UserDefinedReference2: formFields.USERDEFINEDREFERENCE2 || "",
                UserDefinedReference3: formFields.USERDEFINEDREFERENCE3 || "",
                UserDefinedReference4: formFields.USERDEFINEDREFERENCE4 || "",
                UserDefinedReference5: formFields.USERDEFINEDREFERENCE5 || "",
                UserDefinedReference6: formFields.USERDEFINEDREFERENCE6 || "",
                UserDefinedReference7: formFields.USERDEFINEDREFERENCE7 || "",
                UserDefinedReference8: formFields.USERDEFINEDREFERENCE8 || "",
                UserDefinedReference9: formFields.USERDEFINEDREFERENCE9 || "",
                UserDefinedReference10: formFields.USERDEFINEDREFERENCE10 || "",
                UserDefinedComment: formFields.USERDEFINEDCOMMENT || "",
                ApplyReceipt: formFields.APPLY_RECEIPT || "",
                ApplyShipment: formFields.APPLY_SHIPMENT || "",
                RChargeReceipt: formFields.R_CHARGE_RECEIPT || null,
                RChargeShipment: formFields.R_CHARGE_SHIPMENT || null,
                MinimumAmountReceipt: formFields.MINIMUMAMOUNT_RECEIPT,
                MinimumAmountShipment: formFields.MINIMUMAMOUNT_SHIPMENT,
                Status: formFields.STATUS || "A",
            };

            const isUpdate = formFields.ROWID && formFields.ROWID !== "00000000-0000-0000-0000-000000000000";
            const endpoint = isUpdate ? data.RateScheduleCode.UpdateRateScheduleHeader : data.RateScheduleCode.InsertRateScheduleHeader;
            const method = isUpdate ? 'put' : 'post';

            const url = `${window._env_.REACT_APP_APIS}/${endpoint}`;
            const resp = await axios[method](url, payload, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                }
            });

            const saved = resp?.data;
            if (saved) {
                setformFields((prev) => ({
                    ...prev,
                    ROWID: saved.RowId || prev.ROWID,
                    RECORD: saved.Record || prev.RECORD,
                    R_PROFILECODE: saved.RProfileCode || prev.R_PROFILECODE,
                    R_CUSTOMER: saved.RCustomer || prev.R_CUSTOMER,
                    ITEMCLASS: saved.ItemClass || prev.ITEMCLASS,
                    ITEMSUBCLASS: saved.ItemSubClass || prev.ITEMSUBCLASS,
                    SCHEDULECODE: saved.ScheduleCode || prev.SCHEDULECODE,
                    SCHEDULETYPE: saved.ScheduleType || prev.SCHEDULETYPE,
                    DESCRIPTION: saved.Description || prev.DESCRIPTION,
                    SCHEDULEAPPLY: saved.ScheduleApply || prev.SCHEDULEAPPLY,
                    POPUPMESSAGE: saved.PopupMessage || prev.POPUPMESSAGE,
                    COMMENT: saved.Comment || prev.COMMENT,
                    LOTSTORAGEENDDATE: saved.LotStorageEndDate || prev.LOTSTORAGEENDDATE,
                    SUBLOTSTORAGEENDDATE: saved.SublotStorageEndDate || prev.SUBLOTSTORAGEENDDATE,
                    RECURRINGSTORAGE: saved.RecurringStorage || prev.RECURRINGSTORAGE,
                    USERDEFINEDCODE1: saved.UserDefinedCode1 || prev.USERDEFINEDCODE1,
                    USERDEFINEDCODE2: saved.UserDefinedCode2 || prev.USERDEFINEDCODE2,
                    USERDEFINEDCODE3: saved.UserDefinedCode3 || prev.USERDEFINEDCODE3,
                    USERDEFINEDCODE4: saved.UserDefinedCode4 || prev.USERDEFINEDCODE4,
                    USERDEFINEDCODE5: saved.UserDefinedCode5 || prev.USERDEFINEDCODE5,
                    USERDEFINEDCODE6: saved.UserDefinedCode6 || prev.USERDEFINEDCODE6,
                    USERDEFINEDCODE7: saved.UserDefinedCode7 || prev.USERDEFINEDCODE7,
                    USERDEFINEDCODE8: saved.UserDefinedCode8 || prev.USERDEFINEDCODE8,
                    USERDEFINEDCODE9: saved.UserDefinedCode9 || prev.USERDEFINEDCODE9,
                    USERDEFINEDCODE10: saved.UserDefinedCode10 || prev.USERDEFINEDCODE10,
                    USERDEFINEDDATE1: saved.UserDefinedDate1 || prev.USERDEFINEDDATE1,
                    USERDEFINEDDATE2: saved.UserDefinedDate2 || prev.USERDEFINEDDATE2,
                    USERDEFINEDDATE3: saved.UserDefinedDate3 || prev.USERDEFINEDDATE3,
                    USERDEFINEDDATE4: saved.UserDefinedDate4 || prev.USERDEFINEDDATE4,
                    USERDEFINEDDATE5: saved.UserDefinedDate5 || prev.USERDEFINEDDATE5,
                    USERDEFINEDDATE6: saved.UserDefinedDate6 || prev.USERDEFINEDDATE6,
                    USERDEFINEDDATE7: saved.UserDefinedDate7 || prev.USERDEFINEDDATE7,
                    USERDEFINEDDATE8: saved.UserDefinedDate8 || prev.USERDEFINEDDATE8,
                    USERDEFINEDDATE9: saved.UserDefinedDate9 || prev.USERDEFINEDDATE9,
                    USERDEFINEDDATE10: saved.UserDefinedDate10 || prev.USERDEFINEDDATE10,
                    USERDEFINEDQUANTITY1: saved.UserDefinedQuantity1 ?? prev.USERDEFINEDQUANTITY1,
                    USERDEFINEDQUANTITY2: saved.UserDefinedQuantity2 ?? prev.USERDEFINEDQUANTITY2,
                    USERDEFINEDQUANTITY3: saved.UserDefinedQuantity3 ?? prev.USERDEFINEDQUANTITY3,
                    USERDEFINEDQUANTITY4: saved.UserDefinedQuantity4 ?? prev.USERDEFINEDQUANTITY4,
                    USERDEFINEDQUANTITY5: saved.UserDefinedQuantity5 ?? prev.USERDEFINEDQUANTITY5,
                    USERDEFINEDQUANTITY6: saved.UserDefinedQuantity6 ?? prev.USERDEFINEDQUANTITY6,
                    USERDEFINEDQUANTITY7: saved.UserDefinedQuantity7 ?? prev.USERDEFINEDQUANTITY7,
                    USERDEFINEDQUANTITY8: saved.UserDefinedQuantity8 ?? prev.USERDEFINEDQUANTITY8,
                    USERDEFINEDQUANTITY9: saved.UserDefinedQuantity9 ?? prev.USERDEFINEDQUANTITY9,
                    USERDEFINEDQUANTITY10: saved.UserDefinedQuantity10 ?? prev.USERDEFINEDQUANTITY10,
                    USERDEFINEDREFERENCE1: saved.UserDefinedReference1 || prev.USERDEFINEDREFERENCE1,
                    USERDEFINEDREFERENCE2: saved.UserDefinedReference2 || prev.USERDEFINEDREFERENCE2,
                    USERDEFINEDREFERENCE3: saved.UserDefinedReference3 || prev.USERDEFINEDREFERENCE3,
                    USERDEFINEDREFERENCE4: saved.UserDefinedReference4 || prev.USERDEFINEDREFERENCE4,
                    USERDEFINEDREFERENCE5: saved.UserDefinedReference5 || prev.USERDEFINEDREFERENCE5,
                    USERDEFINEDREFERENCE6: saved.UserDefinedReference6 || prev.USERDEFINEDREFERENCE6,
                    USERDEFINEDREFERENCE7: saved.UserDefinedReference7 || prev.USERDEFINEDREFERENCE7,
                    USERDEFINEDREFERENCE8: saved.UserDefinedReference8 || prev.USERDEFINEDREFERENCE8,
                    USERDEFINEDREFERENCE9: saved.UserDefinedReference9 || prev.USERDEFINEDREFERENCE9,
                    USERDEFINEDREFERENCE10: saved.UserDefinedReference10 || prev.USERDEFINEDREFERENCE10,
                    USERDEFINEDCOMMENT: saved.UserDefinedComment || prev.USERDEFINEDCOMMENT,
                    APPLY_RECEIPT: saved.ApplyReceipt || prev.APPLY_RECEIPT,
                    APPLY_SHIPMENT: saved.ApplyShipment || prev.APPLY_SHIPMENT,
                    R_CHARGE_RECEIPT: saved.RChargeReceipt || prev.R_CHARGE_RECEIPT,
                    R_CHARGE_SHIPMENT: saved.RChargeShipment || prev.R_CHARGE_SHIPMENT,
                    MINIMUMAMOUNT_RECEIPT: saved.MinimumAmountReceipt ?? prev.MINIMUMAMOUNT_RECEIPT,
                    MINIMUMAMOUNT_SHIPMENT: saved.MinimumAmountShipment ?? prev.MINIMUMAMOUNT_SHIPMENT,
                    STATUS: saved.Status || prev.STATUS,
                }));
            }

            notify("Rate Schedule Header saved successfully.", "success", 3000);
        } catch (err) {
            const message =
                err?.response?.data?.message ||
                (typeof err?.response?.data === "string" ? err.response.data : null) ||
                err?.message ||
                "Failed to save Rate Schedule Header.";

            notify(message, "error", 5000);
        } finally {
            hideLoadPanel();
        }
    };

    const addNewRecordClick = () => {
        setformFields(initialFormFields);
    };

    const handleReset = () => {
        const rowId = props.id;
        if (rowId && rowId !== '00000000-0000-0000-0000-000000000000') {
            loadRateScheduleHeaderById(rowId);
        } else {
            setformFields(initialFormFields);
        }
    };

    const goBack = () => {
        history.push("/wm/codes/rate-schedule-codes");
    };

    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Rate Schedule Code
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" />
                                </Item>
                            </Toolbar>
                            <TabPanel deferRendering={props.id ? true : false} showNavButtons={true} height={"auto"}>
                                <TabItem title="Primary">
                                    <PrimaryTab
                                        formFields={formFields}
                                        setformFields={setformFields}
                                        formRefs={formRefs}
                                        handleFieldChange={handleFieldChange}
                                    />
                                </TabItem>
                                <TabItem title="Additional">
                                    <AdditionalTab
                                        formFields={formFields}
                                        setformFields={setformFields}
                                        formRefs={formRefs}
                                        handleFieldChange={handleFieldChange}
                                    />
                                </TabItem>
                                <TabItem title="User Defined">
                                    <UserDefinedTab
                                        formFields={formFields}
                                        setformFields={setformFields}
                                        formRefs={formRefs}
                                        handleFieldChange={handleFieldChange}
                                    />
                                </TabItem>
                              
                                <TabItem title="Charges">
                                    <ChargesTab
                                        headerId={formFields.ROWID}
                                    />
                                </TabItem>
                                <TabItem title="Minimums">
                                    <MinimumsTab
                                        formFields={formFields}
                                        setformFields={setformFields}
                                        formRefs={formRefs}
                                        handleFieldChange={handleFieldChange}
                                    />
                                </TabItem>
                            </TabPanel>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(Form);

